import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Log from 'forms-utils-lib/logger/Logger';
import useFetchCrmObjectType from 'framework-listing-lib/hooks/useFetchCrmObjectType';
import useQueryParams from 'FormsUI/components/hooks/router/useQueryParams';
import { getDashboardRoute } from 'FormsUI/lib/RouteGenerators';
import { removeQueryParams } from '../../../../actions/ReactRouter';
import { RELOAD } from 'FormsUI/constants/QueryParams';
const useRefreshHandler = () => {
  const {
    replace
  } = useHistory();
  const dispatch = useDispatch();
  const queryParams = useQueryParams();
  const {
    refetch
  } = useFetchCrmObjectType();
  useEffect(() => {
    if (queryParams[RELOAD]) {
      dispatch(removeQueryParams([RELOAD]));
      refetch().then(() => {
        replace(getDashboardRoute());
      }).catch(({
        xhr
      }) => Log.warn('Failed to refresh the framework table', xhr));
      replace(getDashboardRoute());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
export default useRefreshHandler;